import * as actionTypes from './actionTypes';

const initialState = {
  details: {},
  error: { detailsError: false, message: '' }
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_ACTIVITY_DETAILS_REQUEST:
      return { ...state, details: {} };
    case actionTypes.FETCH_ACTIVITY_DETAILS_SUCCESS:
      return { ...state, details: action.details.data };
    case actionTypes.FETCH_ACTIVITY_DETAILS_FAILURE:
      return { ...state, error: { detailsError: true, messages: action.details.statusText } };
    default:
      return state;
  }
};

export { reducer as default };
